import type { SyntaxNode } from 'web-tree-sitter';
import type { SymbolImportBinding } from '../../types.js';
import { pushBinding, stringLiteralText } from './shared.js';

export function extractCIncludeBindings(
  root: SyntaxNode,
  filePath: string,
  workspaceFiles: ReadonlySet<string>,
): SymbolImportBinding[] {
  const out: SymbolImportBinding[] = [];
  for (const node of root.descendantsOfType('preproc_include')) {
    const pathNode = node.childForFieldName('path');
    if (!pathNode) continue;
    const includePath = stringLiteralText(pathNode);
    const localName = includePath.split('/').filter(Boolean).at(-1)?.replace(/\.(h|hpp)$/, '') ?? includePath;
    pushBinding(out, filePath, workspaceFiles, includePath, localName, localName, 'default', pathNode);
  }
  return out;
}
